/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-04-16 12:51:06
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-06-22 11:51:39
 * @FilePath: /unifyxp-v2-store-portal/src/constrains/DraggableModules/Components/HOC/index.tsx
 */
import React from 'react';

// import { onContentErrorHooks } from 'src/constrains/DraggableModules/tools';
// import { useSelector, useDispatch } from 'react-redux';
// import { useErrorOnChange2 } from 'src/constrains/SalesChannelPreviewPageComponents/tools';

// import GeneralCollapseContent from 'src/constrains/SalesChannelPreviewPageComponents/GeneralCollapseContent';

const useContentGroup = (props) => {
  const {
    droppableId,
    draggableId,
    onItemDelete,
    onItemAdd,
    onItemChange,
    onItemSort,
    onStaticChange,
    onItemReduce,
    onItemDeleteAll,
    onItemReselect,
    onOpenNewTab,
    onModuleTypeChange,
    staticData,
    dynamicData,
    specificError,
  } = props;
  const handleOnOpenNewTab = (data) => {
    if (onOpenNewTab) {
      onOpenNewTab(data);
    }
  };

  const handleItemOnAdd = (posterType, category?, extraProps?) => {
    if (onItemAdd) {
      onItemAdd(draggableId, posterType, category, extraProps);
    }
  };

  const handleItemOnChange = (index, obj, category?, extraProps?) => {
    if (onItemChange) {
      onItemChange(draggableId, index, obj, category, extraProps);
    }
  };

  const handleItemOnSort = (from, to, category?, extraProps?) => {
    if (onItemSort) {
      onItemSort(draggableId, from, to, category, extraProps);
    }
  };

  const handleOnItemDelete = (index, category?, extraProps?) => {
    if (onItemDelete) {
      onItemDelete(draggableId, index, category, extraProps);
    }
  };

  const handleOnItemDeleteAll = (category?, extraProps?) => {
    if (onItemDeleteAll) {
      onItemDeleteAll(draggableId, category, extraProps);
    }
  };

  const handleOnItemReduce = (items, category?, extraProps?) => {
    if (onItemReduce) {
      onItemReduce(draggableId, items, category, extraProps);
    }
  };

  const handleOnReselect = (data, category?, extraProps?) => {
    //
    if (onItemReselect) onItemReselect(draggableId, data, category, extraProps);
  };

  const handleOnModuleTypeChange = (data) => {
    if (onModuleTypeChange) {
      onModuleTypeChange(draggableId, data);
    }
  };

  const handleOnStaticsChange = (obj) => {
    if (onStaticChange) {
      onStaticChange(draggableId, obj);
    }
  };

  return {
    staticData,
    dynamicData,
    handleOnItemDelete: handleOnItemDelete,
    handleItemOnAdd: handleItemOnAdd,
    handleItemOnChange: handleItemOnChange,
    handleItemOnSort: handleItemOnSort,
    handleOnStaticsChange: handleOnStaticsChange,
    handleOnItemReduce,
    handleOnItemDeleteAll,
    handleOnReselect,
    handleOnModuleTypeChange,
    handleOnOpenNewTab,

    specificError: specificError || {},
    droppableId: droppableId,
    draggableId,
  };
};

const ContentGroupHOC = (Component: any, obj?: any) => {
  const WrappedComponent = (props) => {
    const {
      droppableId,
      draggableId,
      onItemDelete,
      onItemAdd,
      onItemChange,
      onItemSort,
      onStaticChange,
      onItemReduce,
      onItemDeleteAll,
      onItemReselect,
      onOpenNewTab,
      onModuleTypeChange,
      staticData,
      dynamicData,
      specificError,
      ...rest
    } = props;

    const handleOnOpenNewTab = (data) => {
      if (onOpenNewTab) {
        onOpenNewTab(data);
      }
    };

    const handleItemOnAdd = (posterType, category?, extraProps?) => {
      if (onItemAdd) {
        onItemAdd(draggableId, posterType, category, extraProps);
      }
    };

    const handleItemOnChange = (index, obj, category?, extraProps?) => {
      if (onItemChange) {
        onItemChange(draggableId, index, obj, category, extraProps);
      }
    };

    const handleItemOnSort = (from, to, category?, extraProps?) => {
      if (onItemSort) {
        onItemSort(draggableId, from, to, category, extraProps);
      }
    };

    const handleOnItemDelete = (index, category?, extraProps?) => {
      if (onItemDelete) {
        onItemDelete(draggableId, index, category, extraProps);
      }
    };

    const handleOnItemDeleteAll = (category?, extraProps?) => {
      if (onItemDeleteAll) {
        onItemDeleteAll(draggableId, category, extraProps);
      }
    };

    const handleOnItemReduce = (items, category?, extraProps?) => {
      if (onItemReduce) {
        onItemReduce(draggableId, items, category, extraProps);
      }
    };

    const handleOnReselect = (data, category?, extraProps?) => {
      //console.log(onItemReselect);
      if (onItemReselect)
        onItemReselect(draggableId, data, category, extraProps);
    };

    const handleOnModuleTypeChange = (data) => {
      if (onModuleTypeChange) {
        onModuleTypeChange(draggableId, data);
      }
    };

    const handleOnStaticsChange = (obj) => {
      if (onStaticChange) {
        onStaticChange(draggableId, obj);
      }
    };

    const returnProps = {
      staticData,
      dynamicData,
      handleOnItemDelete: handleOnItemDelete,
      handleItemOnAdd: handleItemOnAdd,
      handleItemOnChange: handleItemOnChange,
      handleItemOnSort: handleItemOnSort,
      handleOnStaticsChange: handleOnStaticsChange,
      handleOnItemReduce,
      handleOnItemDeleteAll,
      handleOnReselect,
      handleOnModuleTypeChange,
      handleOnOpenNewTab,

      specificError: specificError || {},
      droppableId: droppableId,
      draggableId,

      ...rest,
    };

    return <Component {...returnProps} />;
  };
  return WrappedComponent;
};
export { useContentGroup };
export default ContentGroupHOC;
